import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GtwElementsBaseUrlsModel } from '../../shared/_models/gtw-elements-base-urls.model';
import { DashboardFilterService } from '../dashboard-filter/dashboard-filter.service';
import * as _ from 'lodash-es';
import { GlobalService } from '../../global/services/global.service';
import { WorkspaceService } from '../../workspace/workspace.service';
import { AppService } from '../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  hydratedGlobalParams,
} from '../../shared/workspace-element-context';

@Component({
    selector: 'gtw-detail-diagnostic',
    templateUrl: './detail-diagnostic.component.html',
    styleUrls: ['./detail-diagnostic.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DetailDiagnosticComponent implements OnInit, OnDestroy {
  private readonly subs = new Subscription();

  taxYears: any[] = [];
  baseURLs: GtwElementsBaseUrlsModel = {
    admin: '',
    api: '/gtw',
    custom: '',
    efile: '',
    pdfEngine: '',
    bulkPdfEngine: '',
  };
  GENERAL_CONFIG: any = {};
  globalParams: any = {};
  clientKey: any;
  selectedDrillDownFilterParams: any = {};

  @Output('load-detail-diag-grid') loadDetailDiag = new EventEmitter<any>();

  constructor(
    public dashboardFilterService: DashboardFilterService,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  selectedParams: any;

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.cdr.markForCheck();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.cdr.markForCheck();
      })
    );

    console.log('this is detail filet');
    console.log('selectedFilterParams', this.selectedDrillDownFilterParams);
    let hasSelectedParams = _.find(this.dashboardFilterService.screenFilters, { screen_key: 11460 });
    if (hasSelectedParams && hasSelectedParams.filterParams != undefined) {
      this.selectedParams = hasSelectedParams.filterParams;
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    header.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || header.globalParams || {};
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalParams = header.globalParams || {};
    this.clientKey = this.globalParams.client_key || '';
    this.taxYears = this.globalParams.tax_year ? [this.globalParams.tax_year] : [];
    const drill =
      activeScreen?.data?.selectedDrilldownFilterParams ??
      activeScreen?.data?.selected_drilldown_filter_params ??
      {};
    this.selectedDrillDownFilterParams = drill;
    this.cdr.markForCheck();
  }

  isShow: boolean = true;

  showFilter() {
    this.isShow = !this.isShow;
    this.dashboardFilterService.notifyOther({ screen_key: 11460, isEnabled: true });
    this.cdr.markForCheck();
  }
  closeFilterPanel(event: any) {
    this.isShow = true;
    this.cdr.markForCheck();
  }
  loadDetailGrid(event: any) {
    if (event.screen_key == 11460) {
      this.selectedParams = event;
      this.loadDetailDiag.emit(event);
    }
    this.cdr.markForCheck();
  }
}
